import { render } from "./forget-password.vue?vue&type=template&id=2a42de5a&scoped=true&lang=true"
import script from "./forget-password.vue?vue&type=script&lang=js"
export * from "./forget-password.vue?vue&type=script&lang=js"

import "./forget-password.vue?vue&type=style&index=0&id=2a42de5a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a42de5a"]])

export default __exports__